import { Helpers } from '../../helpers';
import { IInjectionLineStatus } from '../../interfaces/iinjection-line-status';
import { Pad } from '../pad';

export class InjectionLineStatusBase {
  InjectionLineStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Pads_InjectionLineStatus?: Array<Pad> | null;

  constructor(item?: IInjectionLineStatus) {
    if (item) {

      this.InjectionLineStatusId = item.InjectionLineStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Pads_InjectionLineStatus = Helpers.createClassArray(Pad, item.Pads_InjectionLineStatus);
    }
  }
}